import color from "../../resource/color";

export const ACTION_COLOR: Record<string, string> = {
  "เผยแพร่ครั้งแรก": "#1B4586",
  "เลื่อนระดับอัตโนมัติ": "#0068F4",
  "อนุมัติ": "#2ED477",
  "ปรับระดับ": "#9B51E0",
  "ปรับยอด": "#E57300",
  "ปฏิเสธ": "#EB5757",
  "อัปเดต Navision": "#1B4586",
  "ส่งข้อมูลไป Navision": "#1B4586",
  "เปลี่ยนนโยบายการแสดงสิทธิ์ปีหน้า": "#52637A",
  "เปลี่ยนนโยบายการแสดง % Rebate": "#52637A",
  "เปลี่ยนนโยบายการแสดง % Top Up": "#52637A",
  "แก้ไขสิทธิประโยชน์": "#1B7F4B",
};

export function actionColorOf(action: string): string {
  return ACTION_COLOR[action] || color.Grey;
}
